import { TextInput, TextInputProps } from '../text'

export interface PasswordInputProps extends TextInputProps {}

export class PasswordInput extends TextInput {
    protected type = 'password'
}
